import actionTypes from 'constants/actionTypes';

import { TradingOfferType } from 'types/TradingOffer';
import { AddTradingOfferPageProvider } from '../pages/AddTradingOffer/context/AddTradingOfferPageContext';
import AddTradingOfferPage from '../pages/AddTradingOffer';

const AddBuyTradingOfferPageContainer = () => (
  <AddTradingOfferPageProvider
    tradingOfferType={TradingOfferType.BUY}
    actionType={actionTypes.ADD}
  >
    <AddTradingOfferPage />
  </AddTradingOfferPageProvider>
);

export default AddBuyTradingOfferPageContainer;
